export default __webpack_public_path__ + "static/media/Swa-Adhyayan Catalogue.bf860a32.pdf";